import { CreateClientUserFormData } from '~admin/view/components/clients/clients.component';
import { ClientUserCreateRequest } from '~client/model/client-user-create-request';

/**
 * Transforms CreateClientUserFormData to ClientUserCreateRequest
 * @param values
 */
export const getClientUserCreateRequest = (
  values: CreateClientUserFormData,
): ClientUserCreateRequest => {
  const { clientId, firstName, lastName, email } = values;

  return {
    clientId: clientId.toString(),
    clientRoleIds: ['7'],
    completeSetupInEmail: true,
    emailAddress: email,
    firstName,
    lastName,
    username: email,
  };
};



// WEBPACK FOOTER //
// ./view/components/clients/helper/get-create-user-request.helper.ts